
// handle button login
$('#button_login').on("click", function() {
    //get username/password do ajaz call to auth
    var username = $('#input_username').val();
    var password = $('#input_password').val();
    login(username, password);
});

// handle enter key
  $('input').on('keypress', function(e){
      if (e.which === 13){ //13 is enter key
          $('#button_login').trigger("click");
      }
  });


function login(input_username, input_password) {

        var json_msg = {
            username: input_username,
            password: input_password
        };        

        $.ajax({
                method: "POST",
                url: "/",
                data: JSON.stringify(json_msg)
        }).done(function (msg) {
                result = true;
                console.log('successful ajax response ');

            var options =  {
                text: "Logged in successfully", // text of the snackbar
                duration: 3000, // time in milliseconds after the snackbar autohides, 0 is disabled                
                showAction: false
            }

            Snackbar.show(options);
            var next_url = extractUrlQueryParameter(location.href, 'next');
            // handle redirect properly
            if (next_url){
                location.href = next_url;
            } else {
                location.href = '/inspections';
            }

        }).fail(function(jqXHR, textStatus, errorThrown) {
            var options =  {
                text: "Username and/or password not valid", // text of the snackbar
                duration: 6000, // time in milliseconds after the snackbar autohides, 0 is disabled                
                showAction: false
            }            

            if(jqXHR.responseText){
                var json_response = JSON.parse(jqXHR.responseText);
                if(json_response.hasOwnProperty('failure_limit')){
                    console.log('Login Failure Limit Reached');
                    var options =  {
                        text: "Too many failed login attempts. Please try again in 5 minutes.", // text of the snackbar
                        duration: 30000, // time in milliseconds after the snackbar autohides, 0 is disabled                        
                        showAction: false
                    }
                    /*var snackbars = document.querySelectorAll(".snackbar-opened");
                    var i;
                    for (i in snackbars) {
                      snackbars[i].className = 'snackbar';
                    }*/
                }
            }

            Snackbar.show(options);
        })

}

function extractUrlQueryParameter(url, key){
    var match = url.match('[?&]' + key + '=([^&]+)');
    return match ? match[1] : null;
}

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

var csrftoken = getCookie('csrftoken');

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

$.ajaxSetup({
    beforeSend: function(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
            xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
    }
});

